/** "flight" for 1, "flights" otherwise. Pass an explicit plural for irregular nouns. */
export const pluralize = (count: number, singular: string, plural = `${singular}s`): string =>
	count === 1 ? singular : plural

/** "3 flights" — the count and pluralized noun as one label. */
export const countLabel = (count: number, singular: string, plural?: string): string =>
	`${count} ${pluralize(count, singular, plural)}`
